import { useSelectedSeller } from '@/modules/shared/hooks/use-selected-seller'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { useReportStore } from '@/modules/report/useReportsStore'

const months = [
  { id: 1, name: 'Jan' },
  { id: 2, name: 'Fev' },
  { id: 3, name: 'Mar' },
  { id: 4, name: 'Abr' },
  { id: 5, name: 'Mai' },
  { id: 6, name: 'Jun' },
  { id: 7, name: 'Jul' },
  { id: 8, name: 'Ago' },
  { id: 9, name: 'Set' },
  { id: 10, name: 'Out' },
  { id: 11, name: 'Nov' },
  { id: 12, name: 'Dez' },
]

const anoAtual = new Date().getFullYear()

export type SearchFormData = {
  month: string
  year: string
}

export function useFormSearchReport() {
  const selectedSeller = useSelectedSeller()
  const form = useForm<SearchFormData>({
    defaultValues: {
      month: new Date().getMonth().toString(),
      year: new Date().getFullYear().toString(),
    },
  })

  const loadSalesGoal = useReportStore((state) => state.loadSalesGoal)

  function handleSearch(data: SearchFormData) {
    loadSalesGoal(data.month, data.year, selectedSeller)
  }

  useEffect(() => {
    handleSearch(form.getValues())
  }, [selectedSeller])

  function getYears() {
    return Array.from({ length: 5 }).map((_, index) => anoAtual - index)
  }

  return {
    months,
    form,
    handleSearch,
    getYears,
  }
}
